import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import StorageManager from './services/StorageManager';
import { StorageProvider } from './contexts/StorageContext';
import { AuthProvider } from './contexts/AuthContext';
import AuthService from './services/AuthService';

// Initialize services
const storageManager = new StorageManager();
const authService = new AuthService();

// Create root element
const root = ReactDOM.createRoot(document.getElementById('root'));

// Render app with context providers
root.render(
  <React.StrictMode>
    <StorageProvider storage={storageManager}>
      <AuthProvider authService={authService}>
        <App />
      </AuthProvider>
    </StorageProvider>
  </React.StrictMode>
);
